import clsx from 'clsx/lite';
import { twMerge } from 'tailwind-merge';

type ClassValue = string | true | false | null | undefined;

export const c = (...values: ClassValue[]) => clsx(...values);
export const cm = (...values: ClassValue[]) =>
	twMerge(...values.map((x) => (x === true ? false : x)));
